import React, { useState, useRef, useEffect, useContext } from "react";
import SignUpHandler from "../../Apihander/signup/signupHandler";
import { successToast, errorToast } from "../../utils/notificationUtils";
import '../../css/login.css'
import { useForm } from "react-hook-form";
import { GoogleLogin, useGoogleLogin } from '@react-oauth/google';
import SidebarContext from "../../contexts/MyContext";
import { fetchUserInfo } from '../../utils/googleAuthUtils';
import AppleLogin from 'react-apple-login';
import Modal from "../../components/Modal/Modal";
import { detectBrowser } from "../../utils/detectbrowser";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { useMakePayment } from "../../hooks/useMakePayment";
const { detect } = require('detect-browser');

const CreateAccountModal = ({ closeModal, openModal, closePremiumModal }) => {
    const detectbrowser = detect();
    // Brave detection logic
    let detectDeviceName = detectbrowser?.name || "unknown";

    // Check for Brave specifics
    if (detectbrowser?.name === 'chrome') {
        // Additional checks for Brave
        if (navigator.brave || window.navigator.userAgent.includes('Brave')) {
            detectDeviceName = 'brave';
        }
    }
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors }, watch } = useForm();
    const password = watch("password", ""); // Get the value of the password field
    const confirmPassword = watch("confirmPassword", ""); // Get the value of the confirmPassword field

    const abortControllerRef = useRef(null);

    const [load, setLoad] = useState(false);
    const { storeUser, setOpenOtpModal, setStoreOtpUser, isPremium } = useContext(SidebarContext);
    const [loading, setLoading] = useState(false)
    const { handleMakePaymentOfPremium } = useMakePayment();





    const handleLoginClick = () => {
        if (isPremium) {
            closePremiumModal()
        } else {
            closeModal(); // Close the sign-up modal

        }
        openModal(); // Open the login modal
    };


    const onsubmit = async (payload) => {
        const newPayload = {
            ...payload,
            deviceType: detectbrowser.type,
            deviceName: detectDeviceName,
            recipte_id: ""
        }

        try {
            setLoad(true);
            // Call the signUp function from your authentication service
            const data = await SignUpHandler.doHanderSignUp(newPayload);
            if (data?.statusCode === 200) {
                setLoad(false);
                if (isPremium) {
                    closePremiumModal()
                } else {
                    closeModal();
                }
                setOpenOtpModal(true)
                localStorage.setItem('RegisterEmail', data?.data?.user?.email)
                const userWithSubscription = {
                    ...data?.data?.user,
                    isSubscriptionActive: data?.data?.isSubscriptionActive,
                    // hasSubscribe: data?.data?.hasSubscribe
                }
                setStoreOtpUser(JSON.stringify(userWithSubscription))
                localStorage.setItem('token', data?.data?.token)
                // navigate('/')

            } else {
                // Handle non-200 responses
                const errorMessage = data?.response?.data?.message || data?.message || "An error occurred";
                console.log(errorMessage);
                setLoad(false);
                errorToast(errorMessage);
            }
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log('Sign-up request was aborted');
            } else {
                console.error("Sign-up failed:", error);
                const errorMessage = error?.response?.data?.message || error.message || "An error occurred";
                errorToast(errorMessage);
            }
            setLoad(false);
        }

    };

    const handleClose = () => {
        closeModal();
    };


    const login = useGoogleLogin({
        onSuccess: async (response) => {
            try {
                // Check if access_token is available in the response
                if (!response || !response.access_token) {
                    throw new Error('No access token found in response');
                }

                // Extract the access_token from the response
                const token = response.access_token;

                // Fetch user information using the access token
                const userInfo = await fetchUserInfo(token);



                const payload = {
                    name: userInfo?.name,
                    email: userInfo?.email,
                    google_Id: userInfo?.sub,
                    socialType: "GOOGLE",
                    deviceType: detectbrowser.type,
                    deviceName: detectDeviceName,

                };

                // Send the payload to your backend
                const data = await SignUpHandler.doHandlerGoogleLogin(payload);
                // console.log('Google signup successful:', data);

                if (data?.statusCode === 200) {
                    const userWithSubscription = {
                        ...data?.data?.user,
                        isSubscriptionActive: data?.data?.isSubscriptionActive,
                        hasSubscribe: data?.data?.hasSubscribe
                    }
                    storeUser(JSON.stringify(userWithSubscription));
                    closeModal();

                    if (isPremium && !data?.data?.isSubscriptionActive) {
                        await handleMakePaymentOfPremium()

                    } else {
                        // navigate('/')
                        navigate("/dashboard")

                    }
                }

            } catch (error) {
                console.error('Error during login:', error);
            }
        },
        onError: (error) => {
            console.log('Google login failed:', error);
        },
        usePopup: true,
    });



    const handleAppleLoginSuccess = async (response) => {
        // console.log('Apple login success:', response);
        try {
            const decodedToken = jwtDecode(response.id_token);
            const userIdentifier = decodedToken.sub;
            const payload = {
                // name: response.name,
                // email: response.email,
                // apple_id: "",
                identityToken: response?.id_token,
                recipte_id: "",
                socialType: 'APPLE',
                deviceType: detectbrowser.type,
                deviceName: detectDeviceName
            };
            // console.log('payload at time of apple login', payload);
            const data = await SignUpHandler.doHandlerAppleLogin(payload)
            // console.log('Apple login successful:', data);
            if (data?.statusCode === 200) {
                const userWithSubscription = {
                    ...data?.data?.user,
                    isSubscriptionActive: data?.data?.isSubscriptionActive,
                    hasSubscribe: data?.data?.hasSubscribe
                }
                storeUser(JSON.stringify(userWithSubscription));
                closeModal();

                if (isPremium && !data?.data?.isSubscriptionActive) {
                    await handleMakePaymentOfPremium()

                } else {
                    // navigate('/')
                    navigate("/dashboard")

                }
            }
        } catch (error) {
            console.log('Error:', error);
        }

    };

    const handleAppleLoginError = (error) => {
        console.error('Apple login error:', error);
    };



    return (
        <>
            <section className="">
                <div className="container-fluid h-custom">
                    <div
                        className="modal d-block"
                        style={{ background: "#0000009e" }}
                        tabIndex="-1"
                    >
                        <div
                            className="modal-dialog modal-dialog-centered custom-modal-signup"
                        >
                            <div className="modal-content rounded-lg-md-sm " style={{ borderRadius: '20px' }}>
                                <div className="modal-body">
                                    <div className="row signup-main-content">
                                        <div className=" col-lg-5 col-md-5 col-sm-12">
                                            <div className="modal-signup-scroll" >
                                                <form
                                                    className="custom-modal-form"
                                                    method=""
                                                    onSubmit={handleSubmit(onsubmit)}
                                                    noValidate
                                                >
                                                    <div className="main-text">
                                                        <p
                                                            className="text-md main-heading-signup"
                                                        >
                                                            Create a free account
                                                        </p>
                                                        <p
                                                            className="sub-heading-signup">
                                                            Join Voice Recorder, the fastest and easiest way to
                                                            record and edit your voice
                                                        </p>
                                                    </div>
                                                    <div className="form-group custom-input">
                                                        <input
                                                            type="text"
                                                            className={`form-control custom-input-field ${errors.name ? 'error' : ''}`}
                                                            id="name"
                                                            name="name"
                                                            aria-describedby="emailHelp"
                                                            placeholder="Enter your name"
                                                            // onChange={(e) => setName(e.target.value)}
                                                            {...register("name", {
                                                                required: 'Enter your name',
                                                                minLength: {
                                                                    value: 4,
                                                                    message: 'Name should be more than 3 letters'
                                                                }
                                                            })} />
                                                        {errors.name && <span className="error-message">{errors.name.message}</span>}
                                                    </div>
                                                    <div className="form-group custom-input">
                                                        <input
                                                            type="email"
                                                            className={`form-control custom-input-field ${errors.email ? 'error' : ''}`}
                                                            id="email"
                                                            name="email"
                                                            aria-describedby="emailHelp"
                                                            placeholder="Enter your email"
                                                            // onChange={(e) => setEmail(e.target.value)}
                                                            {...register("email", {
                                                                required: 'Email address is required',
                                                                pattern: {
                                                                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                                    message: 'Enter a valid email address'
                                                                }
                                                            })}
                                                        />
                                                        {errors.email && <span className="error-message">{errors.email.message}</span>}

                                                    </div>
                                                    <div className="form-group custom-input">
                                                        <input
                                                            type="password"
                                                            className={`form-control custom-input-field ${errors.password ? 'error' : ''}`}
                                                            id="password"
                                                            name="password"
                                                            placeholder="Enter password"
                                                            // onChange={(e) =>
                                                            //     setPassword(e.target.value)
                                                            // }

                                                            {...register("password", {
                                                                required: 'Enter your password',
                                                                // pattern: {
                                                                //     value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
                                                                //     message: 'Password must contain at least 8 characters, one uppercase, one lowercase, and one number'
                                                                // },
                                                                minLength: {
                                                                    value: 6,
                                                                    message: 'Password should be at least 6 characters'
                                                                },
                                                                maxLength: { value: 12, message: "**Password cannot exceed more than 12 characters" }
                                                            })}
                                                        />
                                                        {errors.password && <span className="error-message">{errors.password.message}</span>}

                                                    </div>
                                                    {/* <div className="form-group custom-input">
                                                        <input
                                                            type="password"
                                                            className={`form-control custom-input-field ${errors.confirmPassword ? 'error' : ''}`}
                                                            id="confirmPassword"
                                                            name="confirmPassword"
                                                            placeholder="Enter confirmPassword"
                                                            // onChange={(e) =>
                                                            //     setConfirmPassword(e.target.value)
                                                            // }
                                                            {...register("confirmPassword", {
                                                                required: 'This field is required',
                                                                validate: value =>


                                                                    value === password || 'Passwords do not match'

                                                            }
                                                        )}
                                                        />
                                                        {errors.confirmPassword && <span className="error-message">{errors.confirmPassword.message}</span>}

                                                    </div> */}
                                                    <div className="form-group custom-input">
                                                        <button
                                                            type="submit"
                                                            className="btn-submit"
                                                            // disabled={
                                                            //     !name || !email || !password || !confirmPassword
                                                            // }
                                                            // style={{
                                                            //     cursor:
                                                            //         !name || !email || !password || !confirmPassword
                                                            //             ? "not-allowed"
                                                            //             : "pointer",
                                                            // }}
                                                            disabled={load}
                                                            style={{ cursor: load ? 'not-allowed' : 'pointer' }}
                                                        >
                                                            {load ? (
                                                                <>
                                                                    <span style={{ marginRight: '10px' }}>Signing Up</span>
                                                                    <div
                                                                        className="spinner-border spinner-login"
                                                                        role="status"
                                                                    >
                                                                        <span className="visually-hidden">Loading...</span>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <span>
                                                                        Sign Up
                                                                    </span>
                                                                </>
                                                            )
                                                            }
                                                        </button>
                                                    </div>
                                                    <div className="form-group m-2 custom-vector-line">
                                                        <img
                                                            src="/img/login/VectorLeft.png"
                                                            alt="left vector"
                                                            className="left-vector"
                                                        />

                                                        <p className="vector-font">OR</p>
                                                        <img
                                                            src="/img/login/VectorRight.png"
                                                            alt="Right vector"
                                                            className="right-vector"
                                                        />
                                                    </div>
                                                    {/* <div className="form-group m-2 social-group"
                                                    >
                                                        <button
                                                            type="button"
                                                            className="social-btn">
                                                            <img
                                                                src="img/login/apple_icon.png"
                                                                alt="Apple"
                                                                className="social-img"
                                                                style={{ marginRight: '5px' }}

                                                            />

                                                            Continue with Apple
                                                        </button>
                                                    </div> */}
                                                    <div className="">
                                                        <AppleLogin
                                                            clientId="com.voicerecorder.memo.client"
                                                            // redirectURI="https://1302-1-voicerec-web.vercel.app/"
                                                            redirectURI='https://voicememo.co/'
                                                            scope={'name email'}
                                                            responseMode="query"
                                                            usePopup={true}
                                                            // onSuccess={handleAppleLoginSuccess}
                                                            // onError={handleAppleLoginError}
                                                            render={(props) => (
                                                                <div className="form-group m-2 social-group" onClick={props.onClick}>
                                                                    <button
                                                                        type="button"
                                                                        className="social-btn"
                                                                        disabled={props.disabled}
                                                                        style={{ fontWeight: "600" }}
                                                                    >
                                                                        <img
                                                                            src="/img/login/apple_icon.png"
                                                                            alt="Apple"
                                                                            className="social-img"
                                                                            style={{ marginRight: '5px' }}
                                                                        />
                                                                        Continue with Apple
                                                                    </button>
                                                                </div>
                                                            )}
                                                            callback={(data) => {
                                                                // console.log(data, 'data apple login ')
                                                                if (data?.authorization) {
                                                                    // const decodeGoogleCred = await jwtDecode(data?.authorization?.id_token);
                                                                    handleAppleLoginSuccess(
                                                                        data?.authorization
                                                                    );
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="form-group m-2 social-group"
                                                        onClick={() => login()}
                                                    >
                                                        <button
                                                            type="button"
                                                            className="social-btn"
                                                            style={{ fontWeight: "600" }}
                                                        >
                                                            <img
                                                                src="/img/login/google_icon.png"
                                                                alt="Apple"
                                                                className="social-img"
                                                            />
                                                            Continue with Google
                                                        </button>
                                                    </div>
                                                    <div
                                                        className="form-group footer-text">
                                                        <p className="text-md text-black-400 terms-privacy-text">
                                                            By proceeding, you agree to our Terms and Privacy
                                                            Policy.
                                                        </p>
                                                        <p
                                                            className="text-md text-black-400 navigation-main-text">
                                                            Already have an acoount?{" "}
                                                            <a className="navigation-text"
                                                                onClick={() => handleLoginClick()}
                                                            >
                                                                Login
                                                            </a>
                                                        </p>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        <div className="col-lg-7 col-md-7 col-sm-12 position-relative">
                                            <div className="d-flex align-item-end justify-content-end">
                                                <button
                                                    type="button"
                                                    className="close-btn"
                                                    data-bs-dismiss="modal"
                                                    aria-label="Close"
                                                    onClick={() => {
                                                        if (!load) {
                                                            handleClose()
                                                        }
                                                    }}
                                                    style={{
                                                        background: load ? "#d1d5db" : "#F1F5F9",
                                                        color: load ? "#9ca3af" : "#94A3B8",
                                                        cursor: load ? "not-allowed" : "pointer"
                                                    }}
                                                >
                                                    <span aria-hidden="true">&times;</span>

                                                </button>
                                            </div>
                                            <div
                                                className="d-none d-sm-flex img-signup-main">
                                                <img
                                                    src="/img/login/signup.png"
                                                    alt="signup"
                                                    className="img-signup"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default CreateAccountModal;
